import { useContext } from "react";
import { ExitModalsContext } from "./exit-modal-context";
import type { ExitModalsCtx } from "./exit-modal-context";

export function useExitModals(): ExitModalsCtx {
  const ctx = useContext(ExitModalsContext);
  if (!ctx) throw new Error("useExitModals must be used within <ExitModalsProvider>");
  return ctx;
}
